(function () {
  'use strict';
  if (window.__nnClothingCatalogBound) return;
  window.__nnClothingCatalogBound = true;
  function cardData(card) {
    var variants = [];
    try { variants = JSON.parse(card.getAttribute('data-clothing-sizes') || '[]'); } catch (error) {}
    return { element: card, type: card.getAttribute('data-product-type') || '', available: card.getAttribute('data-available') === 'true', variants: variants };
  }
  function populate(select, values) {
    if (!select) return;
    values.filter(function (value, index, list) { return value && list.indexOf(value) === index; })
      .sort(function (a, b) { return a.localeCompare(b, document.documentElement.lang || 'nl', { numeric: true }); })
      .forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
  }
  function apply(scope) {
    var typeSelect = scope.querySelector('[data-clothing-type]');
    var sizeSelect = scope.querySelector('[data-clothing-size]');
    var availability = scope.querySelector('[data-clothing-available]');
    var type = typeSelect ? typeSelect.value : '';
    var size = sizeSelect ? sizeSelect.value : '';
    var onlyAvailable = !!(availability && availability.checked);
    var visible = 0;
    (scope.__nnClothingCards || []).forEach(function (card) {
      var sizeMatches = !size || card.variants.some(function (variant) { return variant.value === size && (!onlyAvailable || variant.available); });
      var show = (!type || card.type === type) && sizeMatches && (!onlyAvailable || card.available);
      card.element.hidden = !show;
      if (show) visible += 1;
    });
    var results = scope.querySelector('[data-clothing-results]');
    if (results) results.textContent = (results.getAttribute('data-count-template') || '__count__').replace('__count__', visible);
    var empty = scope.querySelector('[data-clothing-empty]');
    if (empty) empty.hidden = visible > 0;
    var reset = scope.querySelector('[data-clothing-reset]');
    if (reset) reset.disabled = !type && !size && !onlyAvailable;
  }
  function bind(scope) {
    if (scope.__nnClothingCards) return;
    var cards = Array.prototype.map.call(scope.querySelectorAll('[data-nn-clothing-card]'), cardData);
    scope.__nnClothingCards = cards;
    populate(scope.querySelector('[data-clothing-type]'), cards.map(function (card) { return card.type; }));
    var sizes = [];
    cards.forEach(function (card) { card.variants.forEach(function (variant) { sizes.push(variant.value); }); });
    populate(scope.querySelector('[data-clothing-size]'), sizes);
    var filters = scope.querySelector('[data-clothing-filters]');
    if (filters) filters.hidden = false;
    apply(scope);
  }
  function init(root) {
    if (root.matches && root.matches('[data-clothing-catalog]')) bind(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-clothing-catalog]'), bind);
  }
  function updateStock(select) {
    if (window.NNStock) window.NNStock.apply(select.closest('[data-product-section]'));
  }
  document.addEventListener('nn:stock-updated', function () {
    document.querySelectorAll('[data-clothing-catalog]').forEach(function (scope) {
      scope.__nnClothingCards = Array.prototype.map.call(scope.querySelectorAll('[data-nn-clothing-card]'), cardData);
      apply(scope);
    });
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-clothing-type], [data-clothing-size], [data-clothing-available]')) {
      var scope = event.target.closest('[data-clothing-catalog]');
      if (scope) apply(scope);
    }
    if (event.target.matches('[data-variant-select]')) updateStock(event.target);
  });
  document.addEventListener('click', function (event) {
    var reset = event.target.closest('[data-clothing-reset]');
    if (!reset) return;
    var scope = reset.closest('[data-clothing-catalog]');
    if (!scope) return;
    scope.querySelector('[data-clothing-type]').value = '';
    scope.querySelector('[data-clothing-size]').value = '';
    scope.querySelector('[data-clothing-available]').checked = false;
    apply(scope);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
